import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/views/login/index'
import Main from '@/views/main/index'
import AddUser from '@/views/addUser/index'
import Class from '@/views/addUser/class'
import UserManage from '@/views/addUser/userManage'
import Purchaser from '@/views/dataStatistics/purchaser'
import DayData from '@/views/dataStatistics/dayData'
import MonthData from '@/views/dataStatistics/monthData'
import SummaryData from '@/views/dataStatistics/summaryData'
import Synchronization from '@/views/dataStatistics/synchronization'
import WhiteList from '@/views/main/whiteList'
import DataKanban from '@/views/dataStatistics/dataKanban'
import RealTimeKanban from '@/views/dataStatistics/realTimeKanban'
import ProductData from '@/views/dataStatistics/productData'
import OrderRegionKanban from '@/views/dataStatistics/orderRegionKanban'
import Menu from '@/views/main/menu'
import UserRoot from '@/views/main/userRoot'
import WeChatOfficialAccount from '@/views/main/weChatOfficialAccount'
import WeChatThirdPlatform from '@/views/main/weChatThirdPlatform'
import Applets from '@/views/main/applets'
import Codemanage from '@/views/main/codemanage'
import Token from '@/views/main/token'
import Authorization from '@/views/authorization/authorization'
import FanManage from '@/views/weChatPlatfrom/fanManage'
import Device from '@/views/dataStatistics/device'
import ImAccount from '@/views/im/imAccount'
import AddEnterpriseWechat from '@/views/enterpriseWechat/addEnterpriseWechat'
import UserAnalysis from '@/views/weChatPlatfrom/userAnalysis'
import SummaryRetailData from '@/views/dataRetailStatistics/summaryRetailData'
import DayRetailData from '@/views/dataRetailStatistics/dayRetailData'
import CommodityAnalysis from '@/views/dataStatistics/commodityAnalysis'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'adminmain',
      component: Main
    },
    {
      path: '/addUser',
      name: 'addUser',
      component: AddUser
    },
    {
      path: '/class',
      name: 'class',
      component: Class
    },
    {
      path: '/userManage',
      name: 'userManage',
      component: UserManage
    },
    {
      path: '/purchaser',
      name: 'purchaser',
      component: Purchaser
    },
    {
      path: '/dayData',
      name: 'dayData',
      component: DayData
    },
    {
      path: '/monthData',
      name: 'monthData',
      component: MonthData
    },
    {
      path: '/synchronization',
      name: 'synchronization',
      component: Synchronization
    },
    {
      path: '/whiteList',
      name: 'whiteList',
      component: WhiteList
    },
    {
      path: '/dataKanban',
      name: 'dataKanban',
      component: DataKanban
    },
    {
      path: '/realTimeKanban',
      name: 'realTimeKanban',
      component: RealTimeKanban
    },
    {
      path: '/productData',
      name: 'productData',
      component: ProductData
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu
    },
    {
      path: '/userRoot',
      name: 'userRoot',
      component: UserRoot
    },
    {
      path: '/weChatOfficialAccount',
      name: 'weChatOfficialAccount',
      component: WeChatOfficialAccount
    },
    {
      path: '/weChatThirdPlatform',
      name: 'weChatThirdPlatform',
      component: WeChatThirdPlatform
    },
    {
      path: '/token',
      name: 'token',
      component: Token
    },
    {
      path: '/codemanage',
      name: 'codemanage',
      component: Codemanage
    },
    {
      path: '/authorization',
      name: 'authorization',
      component: Authorization
    },
    {
      path: '/summaryData',
      name: 'summaryData',
      component: SummaryData
    },
    {
      path: '/orderRegionKanban',
      name: 'orderRegionKanban',
      component: OrderRegionKanban
    },
    {
      path: '/fanManage',
      name: 'fanManage',
      component: FanManage
    },
    {
      path: '/device',
      name: 'device',
      component: Device
    },
    {
      path: '/imAccount',
      name: 'imAccount',
      component: ImAccount
    },
    {
      path: '/addEnterpriseWechat',
      name: 'addEnterpriseWechat',
      component: AddEnterpriseWechat
    },
    {
      path: '/applets',
      name: 'applets',
      component: Applets
    },
    {
      path: '/userAnalysis',
      name: 'userAnalysis',
      component: UserAnalysis
    },
    {
      path: '/summaryRetailData',
      name: 'summaryRetailData',
      component: SummaryRetailData
    },
    {
      path: '/dayRetailData',
      name: 'dayRetailData',
      component: DayRetailData
    },
    {
      path: '/commodityAnalysis',
      name: 'commodityAnalysis',
      component: CommodityAnalysis
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js